/**
 * @generated SignedSource<<f13aef91f5ab6f63d168554989d6dea8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type getUserUnrestrictedAccessSummaryQuery$variables = Record<PropertyKey, never>;
export type getUserUnrestrictedAccessSummaryQuery$data = {
  readonly trello: {
    readonly userUnrestrictedAccessSummary: {
      readonly topWorkspaces: ReadonlyArray<{
        readonly displayBoardCount: number | null | undefined;
        readonly displayName: string | null | undefined;
        readonly id: string;
      }> | null | undefined;
      readonly totalWorkspaces: number | null | undefined;
    } | null | undefined;
  };
};
export type getUserUnrestrictedAccessSummaryQuery = {
  response: getUserUnrestrictedAccessSummaryQuery$data;
  variables: getUserUnrestrictedAccessSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TrelloQueryApi",
    "kind": "LinkedField",
    "name": "trello",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TrelloUserUnrestrictedAccessSummary",
        "kind": "LinkedField",
        "name": "userUnrestrictedAccessSummary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrelloWorkspaceAccessSummary",
            "kind": "LinkedField",
            "name": "topWorkspaces",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayBoardCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalWorkspaces",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getUserUnrestrictedAccessSummaryQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getUserUnrestrictedAccessSummaryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1d8d3d0add4b92f96c6dd68f42a75567",
    "id": null,
    "metadata": {},
    "name": "getUserUnrestrictedAccessSummaryQuery",
    "operationKind": "query",
    "text": "query getUserUnrestrictedAccessSummaryQuery {\n  trello {\n    userUnrestrictedAccessSummary @optIn(to: \"TrelloUserUnrestrictedAccessSummary\") {\n      topWorkspaces {\n        id\n        displayName\n        displayBoardCount\n      }\n      totalWorkspaces\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b14c762a998c1c6a75430f1b9a4242bb";

export default node;
